"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useGetUser;
var _context = require("../../../services/auth/context");
function useGetUser() {
  const {
    auth
  } = (0, _context.useAuth)();
  if ((auth === null || auth === void 0 ? void 0 : auth.type) === "user") {
    var _ref;
    const {
      user: {
        firstname,
        email
      }
    } = auth;
    const name = (firstname !== null && firstname !== void 0 ? firstname : "").split(" ").shift();
    return {
      ...auth.user,
      displayName: (_ref = name || email.split("@").shift()) !== null && _ref !== void 0 ? _ref : ""
    };
  }
  return null;
}